import { useMode } from "@/lib/ModeContext";

export default function StealthWatermark() {
  const { isMinimal } = useMode();
  if (!isMinimal) return null;

  return (
    <div
      data-testid="stealth-watermark"
      style={{
        position: "fixed",
        bottom: "16px",
        left: "20px",
        zIndex: 5,
        pointerEvents: "none",
        userSelect: "none",
        fontSize: "10px",
        fontFamily: "'Manrope', sans-serif",
        fontWeight: 800,
        letterSpacing: "0.3em",
        textTransform: "uppercase",
        color: "rgba(255,255,255,0.04)",
        mixBlendMode: "screen",
      }}
    >
      MMNTM
    </div>
  );
}
